import { ApiCaller } from '../../../../api-caller.service';
import { PublicAgentsConnector } from './agents';
import { BetaRegistrationConnector } from './beta-registration/beta-registration.connector';
import { GouvConnector } from './gouv';
import { PublicPropertiesConnector } from './properties/public-properties.connector';
import { PublicUsersConnector } from './users';

export class EtxePublicConnector {
  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  gouv = () => new GouvConnector(this.apiCaller, this.prefix);
  betaRegistration = () => new BetaRegistrationConnector(this.apiCaller, this.prefix);
  agents = () => new PublicAgentsConnector(this.apiCaller, this.prefix);
  users = () => new PublicUsersConnector(this.apiCaller, this.prefix);
  properties = () => new PublicPropertiesConnector(this.apiCaller, this.prefix);
}
